import { motion, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { motionSafe, widgetVariants } from "./motion";

/**
 * The surface every step widget sits on. Indented to line up with the
 * assistant's text column so a widget reads as part of the same turn rather
 * than a separate form.
 */
export function StepCard({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const shouldReduce = useReducedMotion();

  return (
    <motion.div
      className={cn("ml-0 sm:ml-10", className)}
      variants={motionSafe(widgetVariants, shouldReduce)}
      initial="hidden"
      animate="visible"
      exit="exit"
      layout="position"
    >
      <div className="rounded-2xl border border-border/70 bg-card/80 p-4 shadow-sm backdrop-blur-sm">
        {children}
      </div>
    </motion.div>
  );
}

/** Small uppercase section heading used inside step cards. */
export function StepCardLabel({ children }: { children: ReactNode }) {
  return (
    <p className="mb-2 text-[11px] font-medium uppercase tracking-widest text-muted-foreground/60">
      {children}
    </p>
  );
}
